
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import Text from '../../common/client/components/Text';

import { CREATE_PROJECT_ACTION_TYPE } from '../../sagas/project';
import {
    CLEAR_PROJECT_LIST_ACTION_TYPE,
    GET_PROJECT_LIST_ACTION_TYPE
} from '../../sagas/projectList';

import { getVersionString } from '../../utils';
import Loading from '../../components/common/Loading';
import ContentNavigation from '../../components/common/ContentNavigation';
import LoginInfo from '../../components/auth/LoginInfo';

import ProjectList from '../../components/projectList/ProjectList';
import DialogCreateProject from '../../components/DialogCreateProject';

const classNames = mergeStyleSets({
    ProjectListPage: {
        height: '100vh',
        width: '100vw',
        alignItems: 'center',
        justifyContent: 'center'
    },
    contentNavigation: {
        width: '800px',
        paddingTop: '8px',
        paddingBottom: '8px',
        marginBottom: '8px',
        borderBottom: '1px solid #cccccc'
    },
    content: {
        width: '800px'
    },
    footer: {
    }
});

class ProjectListPage extends Component {

    componentDidMount() {
        this.props.clearProjectList();
        this.checkFetchProjectList();
    }

    componentDidUpdate(prevProps, prevState) {
        this.checkFetchProjectList();
    }

    checkFetchProjectList() {
        const notLoaded = (!this.props.projectList.loaded && !this.props.projectList.loading && !this.props.authLoading);
        const error = (this.props.projectList.error)
        if (notLoaded && !error)  {
            this.props.getProjectList(this.props.token);
        }
    }

    getIsUserLogged() {
        return (!!this.props.token);
    }

    getNavigationItems() {
        return [
            {title: 'Úvodní strana', path: '#/'},
            {title: 'Seznam projektů', path: '#/projectList'}
        ];
    }

    handleCreateClick = async () => {
        let projectParams = await DialogCreateProject.show();
        if (projectParams) {
            this.props.createProject(this.props.token, projectParams);
        }
    }

    handleProjectClick = (project) => {
        this.props.history.push(`/projectview/${project.id}`);
    }

    handleRefreshClick = () => {
        this.props.getProjectList(this.props.token);
    }

    render() {
        return (
            <Stack verticalFill className={classNames.ProjectListPage}>
                <Stack horizontal className={classNames.contentNavigation}>
                    <Stack.Item grow>
                        <ContentNavigation
                            items={this.getNavigationItems()}
                            paths={[]}
                        />
                    </Stack.Item>
                    <LoginInfo />
                </Stack>
                <Stack.Item grow>
                    {(this.props.projectList.loaded)
                        ? <Stack verticalFill className={classNames.content}>
                            <ProjectList
                                projectList={this.props.projectList.data.projectList}
                                isUserLogged={this.getIsUserLogged()}
                                onCreateClick={this.handleCreateClick}
                                onProjectClick={this.handleProjectClick}
                                onRefreshClick={this.handleRefreshClick}
                            />
                        </Stack>
                        : <Loading />
                    }
                </Stack.Item>
                <Stack.Item className={classNames.footer}>
                    <Text small color="#999999">Verze: {getVersionString()}</Text>
                </Stack.Item>
            </Stack>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        clearProjectList: (token) => dispatch({type: CLEAR_PROJECT_LIST_ACTION_TYPE, token}),
        createProject: (token, params) => dispatch({type: CREATE_PROJECT_ACTION_TYPE.DEFAULT, token, params}),
        getProjectList: (token) => dispatch({type: GET_PROJECT_LIST_ACTION_TYPE.DEFAULT, token}),
    };
}

function mapStateToProps(state, ownProps) {
    return {
        projectList: state.projectList,
        token: state.auth.data ? state.auth.data.user.token : null,
        authLoading: state.auth.loading
    };
}

const ConnectedProjectListPage = connect(mapStateToProps, mapDispatchToProps)(ProjectListPage);

export default ConnectedProjectListPage;
